export default __webpack_public_path__ + "static/media/cotton-green@2x.b125211b.png";